// import React from 'react';

// import { Box,Grid } from '@mui/material';

import * as React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
// import Style from './Terminal.module.scss';
import Style from '../about/Terminal.module.scss';
import classNames from 'classnames';
import { Bloodtype } from '@mui/icons-material';

const iconClass = 'fa fa-circle';
const Item = styled(Paper)(({ theme }) => ({
  //  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  //  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  fontSize:'2.5vh',
  font:"20px",
  
}));

const Content = styled('div')({
  fontSize: '3.5vh', // Adjust the font size as needed
});

const RoleItem = styled('li')({
  color: 'blue', // Change this color to your desired color
  // Add more styling as needed
});

export default function ExpDetails(props) {
  const {title, company,location, year, description} = props;
  return (
    <Box sx={{ width: '100%' }}>
      <Box
       sx={{ backgroundColor: '#46f4a0', minWidth: '300px', color: 'black',width: '100%', marginTop: '15px',
       height: '100%' }}
       p={'0.5rem'}
       borderRadius={'0.5rem 0.5rem 0 0'}
      
     >
       <i className={classNames(iconClass, Style.red)} />
       <i className={classNames(iconClass, Style.amber)} />
       <i className={classNames(iconClass, Style.green)} />
       <span style={{display:'flex', fontSize:'34px', fontFamily:'fantasy', fontWeight:'bolder'}}>{title}</span>
     </Box>

      <Stack spacing={2}>
      <Item style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div style={{textAlign: 'left' }}>
      <span style={{fontWeight:'bold', color: 'black',fontSize:'20px'}}> {company} </span>
      <span style={{fontWeight:'bold', color: 'black',fontSize:'20px'}}> {location} </span>
      </div>
      <div style={{ textAlign: 'right' }}>
       <span style={{fontWeight:'bold', color: 'black',fontSize:'20px'}}> {year} </span>
      </div>
    </Item>
        <Item>
          <Content>
            {description.map((obj, index)=>(
              <ul key = {index}>
              {Object.values(obj).map((role,roleIndex)=>(
                <li key = {roleIndex} style={{ color: '#564182', textAlign:'left',fontSize:'18px', margin:'8px 0', fontFamily:'revert-layer'}}> -{role}</li>
                ))}
              </ul>
              ))}
          </Content>


        </Item>
    
      </Stack>
    </Box>
  );
}












//  const iconClass = 'fa fa-circle';

//  function ExpDetails(props){
//      const {title, company, year, description} = props;

//      return (

//        <Box
      
//        sx={{
        
//          width: '100%',
//          height: '100%',
//          backgroundColor: 'primary.dark',
//          '&:hover': {
//            backgroundColor: 'primary.main',
//            opacity: [0.9, 0.8, 0.7],
//          },
//        }}
      
//      >
//       <Box
//        sx={{ backgroundColor: '#46f4a0', minWidth: '300px', color: 'black',width: '100%',
//        height: '100%' }}
//        p={'0.5rem'}
//        borderRadius={'0.5rem 0.5rem 0 0'}
//        fontSize={'2rem'}
      
//      >
//        <i className={classNames(iconClass, Style.red)} />
//        <i className={classNames(iconClass, Style.amber)} />
//        <i className={classNames(iconClass, Style.green)} />
//        <h3> {title}</h3>
//      </Box>
//      <Box
//        display="flex"
//        flexDirection="column"
//        flex="1"
//        py={{ xs: '1rem', md: '2rem' }}
//        px={{ xs: '2rem', md: '3rem' }}
//        borderRadius={'0 0 0.5rem 0.5rem'}
//        sx={{ backgroundColor: '#02255e', minWidth: '300px', fontWeight:'bold',
//        fontSize:'1.2rem', justifyContent: 'space-between',width: '100%',
//        height: '100%' }}
//        fontSize={'1.5rem'}
//        fontFamily={'Courier New, Courier, monospace'}
      
//      >
//        <p style={{textAlign:'left', fontWeight:'bold',fontSize:'1.2rem', color: 'blue', margin: 0 }} >{company}</p>
//        <p style={{textAlign:'right', fontWeight:'bold',fontSize:'1.2rem', color: 'yellow', margin: 0 }} >{year}</p>
//        {company}
//        {year}
//        {/* {description} */}
//      </Box>
//      </Box>

//       <Box
//       display="flex"
//       flexDirection="column"
//       component={'section'}
//       className={classNames(Style.terminal, Style.shadowed)}
//       width={'90%'}
//       borderRadius={'0.5rem'}
//       mb={'4rem'}
//     >
//       <Box
//         sx={{ backgroundColor: '#46f4a0', minWidth: '300px', color: 'black' }}
//         p={'0.5rem'}
//         borderRadius={'0.5rem 0.5rem 0 0'}
//         fontSize={'2rem'}
      
//       >
//         <i className={classNames(iconClass, Style.red)} />
//         <i className={classNames(iconClass, Style.amber)} />
//         <i className={classNames(iconClass, Style.green)} />
//         <h3> {title}</h3>
//       </Box>
//       <Box
//         display="flex"
//         flexDirection="column"
//         flex="1"
//         py={{ xs: '1rem', md: '2rem' }}
//         px={{ xs: '2rem', md: '3rem' }}
//         borderRadius={'0 0 0.5rem 0.5rem'}
//         sx={{ backgroundColor: '#02255e', minWidth: '300px',  textAlign:'left', fontWeight:'bold',
//         fontSize:'1.2rem', justifyContent: 'space-between', alignItems: 'left', }}
//         fontSize={'1.5rem'}
//         fontFamily={'Courier New, Courier, monospace'}
      
//       >
//         <p style={{textAlign:'left', fontWeight:'bold',fontSize:'1.2rem', color: 'blue', margin: 0 }} >{company}</p>
//         <p style={{textAlign:'right', fontWeight:'bold',fontSize:'1.2rem', color: 'blue', margin: 0 }} >{year}</p>
//         {company}
//         {year}
//         {/* {description} */}
//       </Box>
//     </Box>
  














//           <Box
//             component={'section'}
//             className={classNames(Style.terminal, Style.shadowed)}
//             width={{ xs: '80%', md: '50%' }}
//             borderRadius={'0.5rem'}
//             mb={'4rem'}
//           >
//             <Box
//               sx={{ backgroundColor: '#46f4a0' }}
//               p={'0.5rem'}
//               borderRadius={'0.5rem 0.5rem 0 0'}
//               fontSize={'1rem'}
//             >
//               <i className={classNames(iconClass, Style.red)} />
//               <i className={classNames(iconClass, Style.amber)} />
//               <i className={classNames(iconClass, Style.green)} />
//             </Box>
//             <Box
          
//               py={{ xs: '1rem', md: '2rem' }}
//               px={{ xs: '2rem', md: '3rem' }}
//               borderRadius={'0 0 0.5rem 0.5rem'}
//               sx={{ backgroundColor: '#02255e' }}
//               fontSize={'1.5rem'}
//               fontFamily={'Courier New, Courier, monospace'}
//             >
//               <h1>ddddddd</h1>
           
//             </Box>
//           </Box>
//        );
//  }

//  export default ExpDetails;